<template>
  <DropdownMenu
    v-if="country && country.langCode"
    :list="countryList"
    :selected-id="country.langCode"
    class="list-inline-item dropdown mr-3"
    id-key="langCode"
    @select="selectLanguage"
  >
    <template #button="{ data }">
      <img
        :alt="data.name"
        :src="
          getFileViewUrl(data.icon || `/static/country/${data.langCode}.png`)
        "
        class="mr-2 ls-is-cached lazyloaded"
        height="11"
      />
      <span class="opacity-60">{{ data.name }}</span>
    </template>
    <template #item="{ data, isSelected }">
      <a
        :class="{ active: isSelected }"
        class="dropdown-item"
        href="javascript:void(0)"
      >
        <img
          :alt="data.name"
          :src="
            getFileViewUrl(data.icon || `/static/country/${data.langCode}.png`)
          "
          class="mr-1 ls-is-cached lazyloaded"
          height="11"
        />
        {{ data.name }}
      </a>
    </template>
  </DropdownMenu>
</template>
<script>
import { Locals } from "@/lang";
import DropdownMenu from "@/components/DropdownMenu.vue";

export default {
  name: "LocaleDropdownMenu",
  components: { DropdownMenu },
  data() {
    return {};
  },
  methods: {
    selectLanguage(country) {
      this.$store.dispatch("common/setCountry", country);
      this.$store.dispatch("common/setLang", country.langCode);
      location.reload();
    }
    // selectLanguage(country) {
    //   console.log(country.langKey || country.langCode);
    //   this.$i18n.locale = country.langCode;
    //   this.$store.dispatch("common/setCountry", country);
    //   Locals(country.langKey || country.langCode);
    //   this.$emit("close");
    //   this.$post('/user/info/update', {lang: country.langCode})
    //   location.reload();
    // }
  }
};
</script>
